import React, { ChangeEvent, FC, useRef } from 'react';
import styles from './PhotoPicker.styles';
import { createUseStyles } from 'src/theming';
import { FormHelperText, Grid, Typography } from '@material-ui/core';
import AttachmentFile from './components/AttachmentFile';
import Button from 'src/components/Button';
import { ApiReturnType } from '../../../interfaces/api/api';

const useStyles = createUseStyles(styles);

interface Props {
  error?: boolean;
  helperText?: string;
  itemId?: string;
  getItemAttachmentApi?: (attachmentId: string) => ApiReturnType;
  value: Array<File & { id?: string }>;
  onChange: React.Dispatch<React.SetStateAction<Array<File & { id?: string }>>>;
}

const PhotoPicker: FC<Props> = ({ value, onChange, error, helperText, itemId, getItemAttachmentApi }) => {
  const inputFileRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();

  const onPickFile = async (e: ChangeEvent<HTMLInputElement>) => {
    const targetFiles = e.target?.files || [];

    if (targetFiles.length > 0) {
      onChange([...value, targetFiles[0]]);
    }
  };

  const handleClickAdd = () => {
    inputFileRef.current?.click();
  };

  const handleRemoveFile = (index: number) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    onChange(newValue);
  };

  return (
    <Grid container spacing={1} className={classes.root}>
      <Grid item xs={12}>
        <Typography variant='overline' className={classes.section}>
          Annexes
        </Typography>
      </Grid>

      <input
        style={{ display: 'none' }}
        ref={inputFileRef}
        type='file'
        accept='image/*'
        multiple
        onChange={onPickFile}
      />

      <Grid item xs={12}>
        <div className={classes.list}>
          {value.map((file, key) => (
            <AttachmentFile
              key={key}
              file={file}
              onDelete={() => handleRemoveFile(key)}
              getItemAttachmentApi={getItemAttachmentApi}
              itemId={itemId}
            />
          ))}
        </div>
      </Grid>

      <Grid item xs={12}>
        <Button variant='outlined' color='primary' onClick={handleClickAdd} fullWidth>
          Ajouter une photo
        </Button>
      </Grid>

      {error && (
        <Grid item xs={12}>
          <FormHelperText>{helperText}</FormHelperText>
        </Grid>
      )}
    </Grid>
  );
};

export default PhotoPicker;
